import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { ProviderUserService } from '@sondermind/data-access/provider-user';
import { SondermindApplicationService } from '@sondermind/data-access/sondermind-app-service';
import { ProviderUser, ProfileStates } from '@sondermind/utilities/models-user-provider';

@Component({
  selector: 'member-profile-submit',
  templateUrl: './profile-submit.component.html',
  standalone: false
})
export class ProfileSubmitComponent implements OnInit, OnDestroy {
  user: ProviderUser = null;
  userSub: Subscription;

  saving = false;
  profileStates = ProfileStates;

  constructor(
    private appService: SondermindApplicationService,
    private userService: ProviderUserService,
    private snackBar: MatSnackBar
  ) {
  }

  ngOnInit() {
    // eslint-disable-next-line no-return-assign
    this.userSub = this.appService.currentUser$.subscribe((u) => this.user = u);
  }

  ngOnDestroy() {
    if (this.userSub) {
      this.userSub.unsubscribe();
    }
  }

  submitProfile() {
    this.saving = true;
    this.userService.submitProfile(this.appService.currentUserId)
      .pipe(
        switchMap(() => this.appService.loadCurrentUser())
      )
      .subscribe({
        next: (data) => {
          this.saving = false;
        },
        error: (err) => {
          this.saving = false;
          this.snackBar.open('There was a problem submitting your profile, try again in a moment.', 'Dismiss');
        }
      });
  }
}
